import React from 'react'
import styles from '../AdminPanelPage.module.scss'
import MiniMap from 'pages/ReportCard/MiniMap'
import BranchesList from './BranchesList'
import BaseSearchSelect from './BaseSearchSelect'

const ChppsPanel = ({
  chppsFilter,
  setChppsFilter,
  filteredChpps,
  chppsPagination,
  loadChppsPage,
  openCreateModal,
  startEdit,
  editingChpp,
  editPayloads,
  setEditPayloads,
  saveEdit,
  cancelEdit,
  expandedChpp,
  setExpandedChpp,
  expandedOperatorsChpp,
  setExpandedOperatorsChpp,
  expandedDriversChpp,
  setExpandedDriversChpp,
  expandedBranchesChpp,
  setExpandedBranchesChpp,
  loadOperatorsByChppPage,
  loadDriversByChppPage,
  loadBranchesByChppPage,
  operatorsByChpp,
  driversByChpp,
  branchesByChpp,
  operatorsPaginationByChpp,
  driversPaginationByChpp,
  branchesPaginationByChpp,
  operatorsFilterByChpp,
  driversFilterByChpp,
  branchesFilterByChpp,
  setOperatorsFilterByChpp,
  setDriversFilterByChpp,
  setBranchesFilterByChpp,
  employees,
  editingOperatorByChpp,
  editingDriverByChpp,
  editingBranchByChpp,
  startEditOperator,
  startEditDriver,
  startEditBranch,
  saveEditOperator,
  saveEditDriver,
  saveEditBranch,
  cancelEditOperator,
  cancelEditDriver,
  cancelEditBranch,
  loadOperators,
  loadDriversByChpp,
  expandedDriverByChpp,
  toggleDriver,
  expandedOperatorByChpp,
  toggleOperatorChpp,
  printDriverPass,
  downloadDriverPass,
  chpps,
  topBases = [],
  privatePoints = []
}) => {
  return (
    <div className={styles.panel}>
      <div className={styles.panelHeader}>
        <div className={styles.panelTitle}>Окно: ТЭЦ</div>
        <div>
          <button className={styles.addButton} onClick={() => openCreateModal('chpp')}>Добавить ТЭЦ</button>
        </div>
      </div>
      <div className={styles.panelBody}>
        <div className={styles.searchRow}>
          <input className={styles.searchInput} placeholder="Поиск..." value={chppsFilter} onChange={(e) => setChppsFilter(e.target.value)} onKeyDown={(e) => { if (e.key === 'Enter') loadChppsPage(1, chppsFilter) }} />
        </div>
        {filteredChpps && filteredChpps.length ? (
          <table className={styles.table}>
            <thead>
              <tr>
                <th>№</th>
                <th>Название</th>
                <th>Телефон</th>
                <th>Местоположение</th>
                <th>Действия</th>
              </tr>
            </thead>
            <tbody>
              {filteredChpps.map((cp, index) => (
                <React.Fragment key={cp.id}>
                  <tr className={styles.topBaseRow}>
                    <td>{index + 1}</td>
                    <td className={styles.topBaseTitle} onClick={() => { const newVal = (expandedChpp === cp.id ? null : cp.id); setExpandedChpp(newVal); if (newVal) loadOperatorsByChppPage(cp.id, 1); }}>{cp.name}</td>
                    <td>{cp.phone || '-'}</td>
                    <td>
                      {cp.geo ? (
                        <div style={{ display: 'flex', alignItems: 'center', gap: '8px', flexDirection: 'column' }}>
                          <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                            <button 
                              onClick={() => window.open(`https://www.google.com/maps?q=${cp.geo}`, '_blank')} 
                              className={styles.geoLinkBtn}
                              title="Открыть в Google Maps"
                            >
                              🗺️ Карты
                            </button>
                            <button 
                              onClick={() => {
                                const elem = document.getElementById(`map-chpp-${cp.id}`);
                                if (elem) elem.style.display = elem.style.display === 'none' ? 'block' : 'none';
                              }} 
                              className={styles.mapToggleBtn}
                              title="Показать/скрыть карту"
                            >
                              📌
                            </button>
                          </div>
                          <div id={`map-chpp-${cp.id}`} style={{ width: 200, height: 150, display: 'none' }}>
                            <MiniMap geo={cp.geo} />
                          </div>
                        </div>
                      ) : '-'}
                    </td>
                    <td>
                      <button className={styles.smallBtn} onClick={() => { const newVal = (expandedBranchesChpp === cp.id ? null : cp.id); setExpandedBranchesChpp(newVal); if (newVal) loadBranchesByChppPage(cp.id, 1); setExpandedChpp(cp.id); }}>Филиалы</button>
                      <button className={styles.smallBtn} onClick={() => { const newVal = (expandedOperatorsChpp === cp.id ? null : cp.id); setExpandedOperatorsChpp(newVal); if (newVal) loadOperatorsByChppPage(cp.id, 1); setExpandedChpp(cp.id); }}>Операторы</button>
                      <button className={styles.smallBtn} onClick={() => { const newVal = (expandedDriversChpp === cp.id ? null : cp.id); setExpandedDriversChpp(newVal); if (newVal) loadDriversByChppPage(cp.id, 1); setExpandedChpp(cp.id); }}>Водители</button>
                      <button className={styles.smallBtn} style={{ marginLeft: 8 }} onClick={() => startEdit('chpp', cp.id, { name: cp.name, phone: cp.phone })}>Изменить</button>
                    </td>
                  </tr>
                  {editingChpp === cp.id && (
                    <tr>
                      <td colSpan={5}>
                        <div style={{ padding: 8 }}>
                          <label>Название</label>
                          <input value={(editPayloads[`chpp__${cp.id}`] || {}).name || ''} onChange={(e) => setEditPayloads(p => ({ ...p, [`chpp__${cp.id}`]: { ...p[`chpp__${cp.id}`], name: e.target.value } }))} />
                          <label style={{ marginLeft: 8 }}>Телефон</label>
                          <input value={(editPayloads[`chpp__${cp.id}`] || {}).phone || ''} onChange={(e) => setEditPayloads(p => ({ ...p, [`chpp__${cp.id}`]: { ...p[`chpp__${cp.id}`], phone: e.target.value } }))} />
                          <div style={{ marginTop: 8 }} className={styles.navbattons}>
                            <button className={styles.btn_pin} onClick={() => saveEdit('chpp', cp.id)}>Сохранить</button>
                            <button className={styles.btn_pin_close} style={{ marginLeft: 8 }} onClick={() => cancelEdit('chpp', cp.id)}>Отмена</button>
                          </div>
                        </div>
                      </td>
                    </tr>
                  )}
                  {expandedChpp === cp.id && (
                    <tr>
                      <td colSpan={5}>
                        <div className={styles.operatorsList}>
                          {expandedBranchesChpp === cp.id && (
                            <BranchesList
                              base={cp}
                              baseType="ТЭЦ"
                              branches={branchesByChpp[cp.id]}
                              branchesFilter={branchesFilterByChpp[cp.id]}
                              setBranchesFilter={(v) => setBranchesFilterByChpp(prev => ({ ...prev, [cp.id]: v }))}
                              loadBranchesByBasePage={loadBranchesByChppPage}
                              openCreateModal={openCreateModal}
                              editingBranch={editingBranchByChpp}
                              editPayloads={editPayloads}
                              setEditPayloads={setEditPayloads}
                              startEdit={startEditBranch}
                              saveEdit={saveEditBranch}
                              cancelEdit={cancelEditBranch}
                              branchesPagination={branchesPaginationByChpp[cp.id]}
                            />
                          )}

                          {expandedOperatorsChpp === cp.id && (
                            <OperatorsForChpp
                              cp={cp}
                              operators={operatorsByChpp[cp.id]}
                              operatorsFilter={operatorsFilterByChpp[cp.id]}
                              setOperatorsFilter={(v) => setOperatorsFilterByChpp(prev => ({ ...prev, [cp.id]: v }))}
                              loadOperatorsByChppPage={loadOperatorsByChppPage}
                              employees={employees}
                              openCreateModal={openCreateModal}
                              editingOperatorByChpp={editingOperatorByChpp}
                              editPayloads={editPayloads}
                              setEditPayloads={setEditPayloads}
                              startEdit={startEditOperator}
                              saveEdit={saveEditOperator}
                              cancelEdit={cancelEditOperator}
                              operatorsPagination={operatorsPaginationByChpp[cp.id]}
                              expandedOperatorByChpp={expandedOperatorByChpp}
                              toggleOperator={toggleOperatorChpp}
                            />
                          )}

                          {expandedDriversChpp === cp.id && (
                            <DriversForChpp
                              cp={cp}
                              drivers={driversByChpp[cp.id]}
                              driversFilter={driversFilterByChpp[cp.id]}
                              setDriversFilter={(v) => setDriversFilterByChpp(prev => ({ ...prev, [cp.id]: v }))}
                              loadDriversByChppPage={loadDriversByChppPage}
                              employees={employees}
                              editingDriverByChpp={editingDriverByChpp}
                              editPayloads={editPayloads}
                              setEditPayloads={setEditPayloads}
                              startEdit={startEditDriver}
                              saveEdit={saveEditDriver}
                              openCreateModal={openCreateModal}
                              cancelEdit={cancelEditDriver}
                              driversPagination={driversPaginationByChpp[cp.id]}
                              expandedDriverByChpp={expandedDriverByChpp}
                              toggleDriver={toggleDriver}
                              printDriverPass={printDriverPass}
                              downloadDriverPass={downloadDriverPass}
                              chpps={chpps}
                              topBases={topBases}
                              privatePoints={privatePoints}
                            />
                          )}
                        </div>
                      </td>
                    </tr>
                  )}
                </React.Fragment>
              ))}
            </tbody>
          </table>
        ) : (
          <div>Список ТЭЦ пуст</div>
        )}
        {(!chppsFilter && chppsPagination && chppsPagination.count > 0) && (
          <div className={styles.pagination}>
            <button disabled={!chppsPagination.previous} onClick={() => loadChppsPage((chppsPagination.page || 1) - 1)}>Пред.</button>
            <span>Стр. {chppsPagination.page || 1} — Всего: {chppsPagination.count}</span>
            <button disabled={!chppsPagination.next} onClick={() => loadChppsPage((chppsPagination.page || 1) + 1)}>След.</button>
          </div>
        )}
      </div>
    </div>
  )
}

// Inline components for operators and drivers to keep file self-contained; mimic TopBases versions but with chpp param
const OperatorsForChpp = ({ cp, operators = [], operatorsFilter = '', setOperatorsFilter = () => {}, openCreateModal, loadOperatorsByChppPage = () => {}, employees = [], editingOperatorByChpp = {}, editPayloads = {}, setEditPayloads = () => {}, startEdit = () => {}, saveEdit = () => {}, cancelEdit = () => {}, operatorsPagination = {},  expandedOperatorByChpp = {}, toggleOperator = () => {} }) => (
  <div style={{ marginTop: 12 }}>
    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
      <strong>Операторы этой ТЭЦ</strong>
      <div>
        <button className={styles.smallBtn} onClick={() => openCreateModal('chpp-operator', { chpp: cp.id, chpp_name: cp.name })}>Добавить оператора</button>
      </div>
    </div>
    <div style={{ marginTop: 8 }}>
      <div className={styles.searchRow}>
        <input className={styles.searchInput} placeholder="Поиск..." value={operatorsFilter || ''} onChange={(e) => setOperatorsFilter(e.target.value)} onKeyDown={(e) => { if (e.key === 'Enter') loadOperatorsByChppPage(cp.id, 1, operatorsFilter || '') }} />
      </div>
      {(operators && operators.length) ? (
        <>
          <table className={styles.table}>
            <thead>
              <tr>
                <th>ID</th>
                <th>Сотрудник</th>
                <th>Номер телефона</th>
                <th>Дополнительный ном.тел</th>
                <th>Создано</th>
                <th>Статус</th>
                <th>Действия</th>
              </tr>
            </thead>
            <tbody>
              {operators.filter(op => {
                const q = (operatorsFilter || '').toLowerCase()
                if (!q) return true
                const emp = op.employee_name || String(op.employee)
                return (emp && emp.toLowerCase().includes(q)) || (op.phone && String(op.phone).toLowerCase().includes(q))
              }).map((op) => (
                <React.Fragment key={op.id}>
                  <tr style={{ cursor: 'pointer' }} onClick={() => toggleOperator(cp.id, op.id)}>
                    <td>{op.id}</td>
                    <td>{op.employee_name || op.employee}</td>
                    <td>{op.employee_phone || '-'}</td>
                    <td>{op.phone || '-'}</td>
                    <td>{op.created_at}</td>
                    <td>{op.is_active ? 'Активен' : 'Неактивен'}</td>
                    <td>
                      <button className={styles.smallBtn} onClick={(ev) => { ev.stopPropagation(); startEdit('chpp-operator', { chpp: cp.id, opId: op.id }, { phone: op.phone, is_active: op.is_active, employee: op.employee }) }}>Изменить</button>
                    </td>
                  </tr>
                  {expandedOperatorByChpp[cp.id] === op.id && (
                    <tr>
                      <td colSpan={7} style={{ textAlign: 'start', padding: 12 }}>
                        <div style={{ display: 'inline-block', position: 'relative', textAlign: 'left', width: '100%' }}>
                          <div style={{ marginTop: 16, borderTop: '1px solid #e0e0e0', paddingTop: 12 }}>
                            <strong>Документы оператора:</strong>
                            {op.documents && op.documents.length > 0 ? (
                              <ul style={{ marginTop: 8, paddingLeft: 20 }}>
                                {op.documents.map(doc => (
                                  <li key={doc.id} style={{ marginBottom: 8 }}>
                                    <a href={doc.file_url} target="_blank" rel="noopener noreferrer" style={{ color: '#0d6efd', textDecoration: 'none' }}>
                                      {doc.file_name}
                                    </a>
                                    <span style={{ marginLeft: 8, color: '#666', fontSize: '12px' }}>
                                      ({(doc.file_size / 1024).toFixed(1)} KB) - {new Date(doc.uploaded_at).toLocaleString('ru-RU')}
                                    </span>
                                  </li>
                                ))}
                              </ul>
                            ) : (
                              <div style={{ marginTop: 8, color: '#666', fontStyle: 'italic' }}>Нет документов</div>
                            )}
                          </div>
                        </div>
                      </td>
                    </tr>
                  )}
                  {editingOperatorByChpp[cp.id] === op.id && (
                    <tr>
                      <td colSpan={7}>
                        <div style={{ padding: 8 }}>
                          <label>Сотрудник</label>
                          <select value={(editPayloads[`chpp-operator_${cp.id}_${op.id}`] || {}).employee || ''} onChange={(e) => setEditPayloads(p => ({ ...p, [`chpp-operator_${cp.id}_${op.id}`]: { ...p[`chpp-operator_${cp.id}_${op.id}`], employee: Number(e.target.value) } }))}>
                            <option value="">— Выберите сотрудника —</option>
                            {employees.map(emp => (<option key={emp.id} value={emp.id}>{emp.label}</option>))}
                          </select>
                          <label style={{ marginLeft: 8 }}>Телефон</label>
                          <input value={(editPayloads[`chpp-operator_${cp.id}_${op.id}`] || {}).phone || ''} onChange={(e) => setEditPayloads(p => ({ ...p, [`chpp-operator_${cp.id}_${op.id}`]: { ...p[`chpp-operator_${cp.id}_${op.id}`], phone: e.target.value } }))} />
                          <label style={{ marginLeft: 8 }}>Активен</label>
                          <input type="checkbox" checked={(editPayloads[`chpp-operator_${cp.id}_${op.id}`] || {}).is_active || false} onChange={(e) => setEditPayloads(p => ({ ...p, [`chpp-operator_${cp.id}_${op.id}`]: { ...p[`chpp-operator_${cp.id}_${op.id}`], is_active: e.target.checked } }))} />
                          
                          <div style={{ marginTop: 8 }}>
                            <label>Документы</label>
                            <input 
                              type="file" 
                              multiple 
                              accept=".pdf,.doc,.docx,.jpg,.jpeg,.png,.webp"
                              onChange={(e) => {
                                const files = Array.from(e.target.files || [])
                                setEditPayloads(p => ({ 
                                  ...p, 
                                  [`chpp-operator_${cp.id}_${op.id}`]: { 
                                    ...p[`chpp-operator_${cp.id}_${op.id}`], 
                                    newDocuments: files 
                                  } 
                                }))
                              }}
                            />
                            {op.documents && op.documents.length > 0 && (
                              <div style={{ marginTop: 4, fontSize: '0.9em' }}>
                                <strong>Текущие документы:</strong>
                                <ul style={{ margin: '4px 0', paddingLeft: 20 }}>
                                  {op.documents.map(doc => (
                                    <li key={doc.id}>
                                      <a href={doc.file_url} target="_blank" rel="noopener noreferrer">
                                        {doc.file_name}
                                      </a>
                                    </li>
                                  ))}
                                </ul>
                              </div>
                            )}
                          </div>
                          
                          <div style={{ marginTop: 8 }}>
                            <button className={styles.btn_pin} onClick={() => saveEdit('chpp-operator', { chpp: cp.id, opId: op.id })}>Сохранить</button>
                            <button className={styles.btn_pin_close} style={{ marginLeft: 8 }} onClick={() => cancelEdit('chpp-operator', { chpp: cp.id })}>Отмена</button>
                          </div>
                        </div>
                      </td>
                    </tr>
                  )}
                </React.Fragment>
              ))}
            </tbody>
          </table>
          {(!operatorsFilter && operatorsPagination && operatorsPagination.count > 0) && (
            <div className={styles.pagination}>
              <button disabled={!operatorsPagination.previous} onClick={() => loadOperatorsByChppPage(cp.id, (operatorsPagination.page || 1) - 1)}>Пред.</button>
              <span>Стр. {operatorsPagination.page || 1} — Всего: {operatorsPagination.count}</span>
              <button disabled={!operatorsPagination.next} onClick={() => loadOperatorsByChppPage(cp.id, (operatorsPagination.page || 1) + 1)}>След.</button>
            </div>
          )}
        </>
      ) : (
        <div>Операторы не найдены</div>
      )}
    </div>
  </div>
)

const DriversForChpp = ({ cp, drivers = [], driversFilter = '', setDriversFilter = () => {}, openCreateModal, loadDriversByChppPage = () => {}, employees = [], editingDriverByChpp = {}, editPayloads = {}, setEditPayloads = () => {}, startEdit = () => {}, saveEdit = () => {}, cancelEdit = () => {}, driversPagination = {}, expandedDriverByChpp = {}, toggleDriver = () => {}, printDriverPass = () => {}, downloadDriverPass = () => {}, chpps = [], topBases = [], privatePoints = [] }) => (
  <div style={{ marginTop: 12 }}>
    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
      <strong>Водители этой ТЭЦ</strong>
      <div>
        <button className={styles.smallBtn} onClick={() => openCreateModal('chpp-driver', { chpp: cp.id, chpp_name: cp.name })}>Добавить водителя</button>
      </div>
    </div>
    <div style={{ marginTop: 8 }}>
      <div className={styles.searchRow}>
        <input className={styles.searchInput} placeholder="Поиск..." value={driversFilter || ''} onChange={(e) => setDriversFilter(e.target.value)} onKeyDown={(e) => { if (e.key === 'Enter') loadDriversByChppPage(cp.id, 1, driversFilter || '') }} />
      </div>
      {(drivers && drivers.length) ? (
        <>
          <table className={styles.table}>
            <thead>
              <tr>
                <th>№</th>
                <th>Сотрудник</th>
                <th>Телефон</th>
                <th>Дополнительный ном.тел.</th>
                <th>Номер машины</th>
                <th>Модель машины</th>
                <th>UID</th>
                <th>QR string</th>
                <th>Фото</th>
                <th>QR (изображение)</th>
                <th>Создано</th>
                <th>Статус</th>
                <th>Статус машины</th>
                <th>Действия</th>
              </tr>
            </thead>
            <tbody>
              {drivers.map((d, index) => (
                <React.Fragment key={d.id}>
                  <tr onClick={(e) => { if (e.target && (e.target.tagName === 'BUTTON' || e.target.tagName === 'A' || e.target.tagName === 'INPUT' || e.target.tagName === 'IMG' || e.target.closest && e.target.closest('button')) ) return; toggleDriver(cp.id, d.id) }} style={{ cursor: 'pointer' }}>
                    <td>{index + 1}</td>
                    <td>{d.employee_name || d.employee}</td>
                    <td>{d.employee_phone || '-'}</td>
                    <td>{d.phone || '-'}</td>
                    <td>{d.vehicle_number || '-'}</td>
                    <td>{d.vehicle_model || '-'}</td>
                    <td>
                      {d.uid ? (
                        <button className={styles.uidBtn} onClick={(ev) => {
                          ev.stopPropagation();
                          try {
                            if (navigator && navigator.clipboard && navigator.clipboard.writeText) {
                              navigator.clipboard.writeText(d.uid)
                            } else {
                              const ta = document.createElement('textarea')
                              ta.value = d.uid
                              document.body.appendChild(ta)
                              ta.select()
                              document.execCommand('copy')
                              ta.remove()
                            }
                          } catch (e) {
                            // ignore
                          }
                        }}>{d.uid}</button>
                      ) : '-' }
                    </td>
                    <td>{d.qrcode_scr || '-'}</td>
                    <td>
                      {d.photo ? (
                        <img className={styles.thumb} src={(d.photo && d.photo.url) ? d.photo.url : d.photo} alt={`photo-${d.id}`} />
                      ) : '-'}
                    </td>
                    <td>
                      {d.qrcode_img ? (
                        <img className={styles.thumb} style={{ cursor: 'pointer' }} onClick={(ev) => { ev.stopPropagation(); downloadDriverPass(d, 'ТЭЦ', chpps.find(x => String(x.id) === String(d.chpp))?.name || '') }} src={(d.qrcode_img && d.qrcode_img.url) ? d.qrcode_img.url : d.qrcode_img} alt={`qrcode-${d.id}`} />
                      ) : '-'}
                    </td>
                    <td>{d.created_at}</td>
                    <td>{d.is_active ? 'Активен' : 'Неактивен'}</td>
                    <td>{d.status_display}</td>
                    <td>
                      <button className={styles.smallBtn} onClick={(ev) => { ev.stopPropagation(); startEdit('chpp-driver', { chpp: cp.id, drId: d.id }, { employee: d.employee, chpp: d.chpp || cp.id, vehicle_number: d.vehicle_number, vehicle_model: d.vehicle_model, phone: d.phone, is_active: d.is_active }) }}>Изменить</button>
                    </td>
                  </tr>
                  {expandedDriverByChpp[cp.id] === d.id && (
                    <tr>
                      <td colSpan={14} style={{ textAlign: 'start', padding: 12 }}>
                        <div style={{ display: 'inline-block', position: 'relative', textAlign: 'left', width: '100%' }}>
                          <div style={{ display: 'flex', gap: 8, justifyContent: 'center' }}>
                            <button className={styles.smallBtn} onClick={(ev) => { ev.stopPropagation(); printDriverPass(d, 'ТЭЦ', chpps.find(x => String(x.id) === String(d.chpp))?.name || '') }}>Печать</button>
                          </div>
                          
                          {/* Документы водителя */}
                          <div style={{ marginTop: 16, borderTop: '1px solid #e0e0e0', paddingTop: 12 }}>
                            <strong>Документы водителя:</strong>
                            {d.documents && d.documents.length > 0 ? (
                              <ul style={{ marginTop: 8, paddingLeft: 20 }}>
                                {d.documents.map(doc => (
                                  <li key={doc.id} style={{ marginBottom: 8 }}>
                                    <a href={doc.file_url} target="_blank" rel="noopener noreferrer" style={{ color: '#0d6efd', textDecoration: 'none' }}>
                                      {doc.file_name}
                                    </a>
                                    <span style={{ marginLeft: 8, color: '#666', fontSize: '12px' }}>
                                      ({(doc.file_size / 1024).toFixed(1)} KB) - {new Date(doc.uploaded_at).toLocaleString('ru-RU')}
                                    </span>
                                  </li>
                                ))}
                              </ul>
                            ) : (
                              <div style={{ marginTop: 8, color: '#666', fontStyle: 'italic' }}>Нет документов</div>
                            )}
                          </div>
                        </div>
                      </td>
                    </tr>
                  )}
                  {editingDriverByChpp[cp.id] === d.id && (
                    <tr>
                      <td colSpan={14}>
                        <div style={{ padding: 8 }}>
                          <label>Сотрудник</label>
                          <div style={{ display: 'inline-block', minWidth: 220 }}>
                            <input placeholder="Поиск сотрудника..." value={''} onChange={() => {}} />
                            <select value={(editPayloads[`chpp-driver_${cp.id}_${d.id}`] || {}).employee || ''} onChange={(e) => { setEditPayloads(p => ({ ...p, [`chpp-driver_${cp.id}_${d.id}`]: { ...p[`chpp-driver_${cp.id}_${d.id}`], employee: Number(e.target.value) } })); }}>
                              <option value="">— Выберите сотрудника —</option>
                              {employees.map(emp => (<option key={emp.id} value={emp.id}>{emp.label}</option>))}
                            </select>
                          </div>
                          <label style={{ marginLeft: 8 }}>Тип базы</label>
                          <select 
                            value={(editPayloads[`chpp-driver_${cp.id}_${d.id}`] || {}).base_type || (d.top_base ? 'top_base' : d.chpp ? 'chpp' : 'private_point')} 
                            onChange={(e) => { 
                              const baseType = e.target.value;
                              setEditPayloads(p => ({ 
                                ...p, 
                                [`chpp-driver_${cp.id}_${d.id}`]: { 
                                  ...p[`chpp-driver_${cp.id}_${d.id}`], 
                                  base_type: baseType,
                                  top_base: baseType === 'top_base' ? (p[`chpp-driver_${cp.id}_${d.id}`]?.top_base || null) : null,
                                  chpp: baseType === 'chpp' ? (p[`chpp-driver_${cp.id}_${d.id}`]?.chpp || null) : null,
                                  private_point: baseType === 'private_point' ? (p[`chpp-driver_${cp.id}_${d.id}`]?.private_point || null) : null
                                } 
                              })); 
                            }}
                            style={{ marginLeft: 8 }}
                          >
                            <option value="top_base">ТОП-База</option>
                            <option value="chpp">ТЭЦ</option>
                            <option value="private_point">Соц.объект/МСУ</option>
                          </select>
                          <label style={{ marginLeft: 8 }}>
                            {(editPayloads[`chpp-driver_${cp.id}_${d.id}`] || {}).base_type === 'chpp' ? 'ТЭЦ' : 
                             (editPayloads[`chpp-driver_${cp.id}_${d.id}`] || {}).base_type === 'private_point' ? 'Соц.объект/МСУ' : 'ТОП-База'}
                          </label>
                          <BaseSearchSelect
                            baseType={(editPayloads[`chpp-driver_${cp.id}_${d.id}`] || {}).base_type || (d.top_base ? 'top_base' : d.chpp ? 'chpp' : 'private_point')}
                            value={
                              (editPayloads[`chpp-driver_${cp.id}_${d.id}`] || {}).base_type === 'chpp' ? 
                                ((editPayloads[`chpp-driver_${cp.id}_${d.id}`] || {}).chpp || d.chpp || cp.id) : 
                              (editPayloads[`chpp-driver_${cp.id}_${d.id}`] || {}).base_type === 'private_point' ? 
                                ((editPayloads[`chpp-driver_${cp.id}_${d.id}`] || {}).private_point || d.private_point || '') : 
                                ((editPayloads[`chpp-driver_${cp.id}_${d.id}`] || {}).top_base || d.top_base || '')
                            }
                            onChange={(baseId) => {
                              const baseType = (editPayloads[`chpp-driver_${cp.id}_${d.id}`] || {}).base_type || (d.top_base ? 'top_base' : d.chpp ? 'chpp' : 'private_point');
                              setEditPayloads(p => ({ 
                                ...p, 
                                [`chpp-driver_${cp.id}_${d.id}`]: { 
                                  ...p[`chpp-driver_${cp.id}_${d.id}`], 
                                  [baseType]: baseId
                                } 
                              }));
                            }}
                            placeholder="Поиск базы..."
                            style={{ marginLeft: 8 }}
                          />
                          <label style={{ marginLeft: 8 }}>Номер машины</label>
                          <input value={(editPayloads[`chpp-driver_${cp.id}_${d.id}`] || {}).vehicle_number || ''} onChange={(e) => setEditPayloads(p => ({ ...p, [`chpp-driver_${cp.id}_${d.id}`]: { ...p[`chpp-driver_${cp.id}_${d.id}`], vehicle_number: e.target.value } }))} />
                          <label style={{ marginLeft: 8 }}>Модель</label>
                          <input value={(editPayloads[`chpp-driver_${cp.id}_${d.id}`] || {}).vehicle_model || ''} onChange={(e) => setEditPayloads(p => ({ ...p, [`chpp-driver_${cp.id}_${d.id}`]: { ...p[`chpp-driver_${cp.id}_${d.id}`], vehicle_model: e.target.value } }))} />
                          <label style={{ marginLeft: 8 }}>Телефон</label>
                          <input value={(editPayloads[`chpp-driver_${cp.id}_${d.id}`] || {}).phone || ''} onChange={(e) => setEditPayloads(p => ({ ...p, [`chpp-driver_${cp.id}_${d.id}`]: { ...p[`chpp-driver_${cp.id}_${d.id}`], phone: e.target.value } }))} />
                          <label style={{ marginLeft: 8 }}>Активен</label>
                          <input type="checkbox" checked={(editPayloads[`chpp-driver_${cp.id}_${d.id}`] || {}).is_active || false} onChange={(e) => setEditPayloads(p => ({ ...p, [`chpp-driver_${cp.id}_${d.id}`]: { ...p[`chpp-driver_${cp.id}_${d.id}`], is_active: e.target.checked } }))} />
                          
                          <div style={{ marginTop: 8 }}>
                            <label>Документы</label>
                            <input 
                              type="file" 
                              multiple 
                              accept=".pdf,.doc,.docx,.jpg,.jpeg,.png,.webp"
                              onChange={(e) => {
                                const files = Array.from(e.target.files || [])
                                setEditPayloads(p => ({ 
                                  ...p, 
                                  [`chpp-driver_${cp.id}_${d.id}`]: { 
                                    ...p[`chpp-driver_${cp.id}_${d.id}`], 
                                    newDocuments: files 
                                  } 
                                }))
                              }}
                            />
                            {d.documents && d.documents.length > 0 && (
                              <div style={{ marginTop: 4, fontSize: '0.9em' }}>
                                <strong>Текущие документы:</strong>
                                <ul style={{ margin: '4px 0', paddingLeft: 20 }}>
                                  {d.documents.map(doc => (
                                    <li key={doc.id}>
                                      <a href={doc.file_url} target="_blank" rel="noopener noreferrer">
                                        {doc.file_name}
                                      </a>
                                    </li>
                                  ))}
                                </ul>
                              </div>
                            )}
                          </div>
                          
                          <div style={{ marginTop: 8 }}>
                            <button className={styles.btn_pin} onClick={() => saveEdit('chpp-driver', { chpp: cp.id, drId: d.id })}>Сохранить</button>
                            <button className={styles.btn_pin_close} style={{ marginLeft: 8 }} onClick={() => cancelEdit('chpp-driver', { chpp: cp.id })}>Отмена</button>
                          </div>
                        </div>
                      </td>
                    </tr>
                  )}
                </React.Fragment>
              ))}
            </tbody>
          </table>
          {(driversPagination && driversPagination.count > 0) && (
            <div className={styles.pagination}>
              <button disabled={!driversPagination.previous} onClick={() => loadDriversByChppPage(cp.id, (driversPagination.page || 1) - 1, driversFilter)}>Пред.</button>
              <span>Стр. {driversPagination.page || 1} из {Math.ceil(driversPagination.count / 25)} — Всего: {driversPagination.count}</span>
              <button disabled={!driversPagination.next} onClick={() => loadDriversByChppPage(cp.id, (driversPagination.page || 1) + 1, driversFilter)}>След.</button>
            </div>
          )}
        </>
      ) : (
        <div>Нет водителей для этой ТЭЦ</div>
      )}
    </div>
  </div>
)

export default ChppsPanel
